export default __webpack_public_path__ + "static/media/Agent_Targets_CSV.cda20352.csv";